import { OrderDetails } from "./orderdetails";
import { OrderSummaryResponse } from "./ordersummaryrequest";

export class OrderDetailsResponse extends OrderSummaryResponse{


     orderDetailsDtoList:OrderDetails[];

}